<template lang="pug">
.writing-board_container
  .writing-board(ref="writeBoard", :id="`writeBoard-${id}`")
    a#clearCanvas(href="javascript:;")
</template>

<script>
/* eslint-disable */
import { defineComponent, ref, onMounted, nextTick } from 'vue';

export default defineComponent({
  name: 'WritingBoard',
  components: {
  },
  props: {
    id: {
      type: String,
      default: new Date().getTime(),
    },
  },
  setup() {
    const writeBoard = ref(null);
    const canvasHeight = ref(0);
    function lineCanvas(options) {
      this.lineWidth = 1;
      this.color = "#000";
      this.background = "#fff";
      for (let op in options) {
        this[op] = options[op];
      };
      const parentRect = this.el.getBoundingClientRect();
      // 计算 paddingX 和 paddingY
      this.paddingX = parentRect.left + this.el.offsetLeft;
      this.paddingY = parentRect.top + (document.documentElement.scrollTop || document.body.scrollTop)
      this.canvas = document.createElement("canvas");
      this.el.prepend(this.canvas);
      this.cxt = this.canvas.getContext("2d");
      this.canvas.width = parentRect.width;
      this.canvas.height = canvasHeight.value;
      const width = this.canvas.width;
      const height = this.canvas.height;
      // 根据 devicePixelRatio 进行放大处理，减少锯齿
      if (window.devicePixelRatio) {
        this.canvas.style.width = width + "px";
        this.canvas.style.height = height + "px";
        this.canvas.height = height * window.devicePixelRatio;
        this.canvas.width = width * window.devicePixelRatio;
        this.cxt.scale(window.devicePixelRatio, window.devicePixelRatio);
      }
      this.el.style.height = `${canvasHeight.value}px`;
      this.cxt.fillStyle = this.background;
      this.cxt.fillRect(0, 0, this.canvas.width, this.canvas.height);
      this.cxt.strokeStyle = this.color;
      this.cxt.lineWidth = this.lineWidth;
      this.cxt.lineCap = "round";
      //开始绘制
      this.canvas.addEventListener("touchstart", function (e) {
        this.cxt.beginPath();
        this.cxt.moveTo(e.changedTouches[0].pageX-this.paddingX, e.changedTouches[0].pageY-this.paddingY);
      }.bind(this), false);
      //绘制中
      this.canvas.addEventListener("touchmove", function (e) {
        this.cxt.lineTo(e.changedTouches[0].pageX-this.paddingX, e.changedTouches[0].pageY-this.paddingY);
        this.cxt.stroke();
        e.preventDefault()
        return false;
      }.bind(this), false);
      //结束绘制
      this.canvas.addEventListener("touchend", function () {
        this.cxt.closePath();
      }.bind(this), false);
      //清除画布
      this.clearEl.addEventListener("click", function () {
        this.cxt.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.cxt.fillRect(0, 0, this.canvas.width, this.canvas.height);
      }.bind(this), false);
    };

    const init = (height) => {
      canvasHeight.value = height;
      let bgColor = "rgba(244, 245, 247, 0.6)";
      let fColor = "#2A2B2E";
      if (document.querySelector('.dark')) {
        bgColor = "rgba(47, 47, 48, 0.6)";
        fColor = "#E1E3E6";
      }

      nextTick(() => {
        setTimeout(() => {
          new lineCanvas({
            el: writeBoard.value, //绘制canvas的父级div
            clearEl: document.getElementById("clearCanvas"), //清除按钮
            lineWidth: 4, //线条粗细，选填
            color: fColor, //线条颜色，选填
            background: bgColor, //线条背景，选填
            paddingX: 0, // x轴偏移量
            paddingY: 0, // y轴偏移量
          });
        }, 500);
      });
    }

    const clear = () => {
      document.getElementById("clearCanvas").click();
    };

    return {
      writeBoard,
      clear,
      init,
    };
  },
})
</script>

<style lang="stylus" scoped>
  .writing-board_container
    display block
    .writing-board
      position relative
      z-index 1
      border-radius 0.32rem
      overflow hidden
      canvas
        display block
    #clearCanvas
      position absolute
      bottom 0.28rem
      /*top 0.28rem*/
      right 0.28rem
      z-index 2
      width 0.64rem
      height 0.64rem
      background url("../assets/clear-btn.png") 50% 50% no-repeat
      background-size contain
</style>
<style lang="stylus" scoped>
.dark
  .writing-board_container
    #clearCanvas
      background url("../assets/clear-btn-dark.png") 50% 50% no-repeat
      background-size contain
</style>
